import { render, staticRenderFns } from "./ActiveResult.vue?vue&type=template&id=582da328&scoped=true&"
import script from "./ActiveResult.vue?vue&type=script&lang=js&"
export * from "./ActiveResult.vue?vue&type=script&lang=js&"
import style0 from "./ActiveResult.vue?vue&type=style&index=0&id=582da328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582da328",
  null
  
)

export default component.exports